var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83332 7.58325C5.83332 7.58325 3.65748 4.78325 2.47915 3.27242C2.18165 2.88742 2.45582 2.33325 2.93998 2.33325H11.0541C11.5383 2.33325 11.8125 2.88742 11.515 3.27242C10.3366 4.78325 8.16665 7.58325 8.16665 7.58325V11.0833C8.16665 11.4041 7.90415 11.6666 7.58332 11.6666H6.41665C6.09581 11.6666 5.83332 11.4041 5.83332 11.0833V7.58325ZM9.91665 3.49992H4.08332L6.99415 7.17492L9.91665 3.49992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.6ce349071a10e9f12f96754be7631e4c.svg";
export { ForwardRef as ReactComponent };